import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-w-shenhe2",
  "use": "icon-w-shenhe2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-w-shenhe2\"><path d=\"M128 896h768c70.4 0 128-57.6 128-128s-57.6-128-128-128h-256v-25.6c115.2-51.2 192-160 192-294.4 0-179.2-140.8-320-320-320S192 140.8 192 320c0 134.4 76.8 243.2 192 294.4v25.6H128c-70.4 0-128 57.6-128 128s57.6 128 128 128zM992 960H32c-19.2 0-32 12.8-32 32s12.8 32 32 32h960c19.2 0 32-12.8 32-32s-12.8-32-32-32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol